import React, { useEffect, useRef, useState } from 'react';

import { observer } from 'mobx-react-lite';

import { FairnessFormGroup } from '@pascal/pascal-core';

import { selectedResultInfoStore } from '../../store/selectedResultInfoStore';

import { ResultImg } from './resultImg';
// import { InputsGroup } from './inputsGroup';
// import { CheckHashButton } from './checkHashButton';
import { AboutHash } from '../aboutHashComp/aboutHash';

export const CheckHashPopup = observer(() => {
  const { selectedResultInfo } = selectedResultInfoStore;
  const scrollRef = useRef(null);
  const [toggle, setToggle] = useState(false);
  // const [checkKeyValue, setCheckKeyValue] = useState('');
  // const [checkSaltValue, setCheckSaltValue] = useState('');
  // const [checkHashValue, setCheckHashValue] = useState('');

  // const handleCheckHash = async () => {
  //   const postData = {
  //     resultIdentityString: checkKeyValue,
  //     salt: checkSaltValue,
  //   };
  //   const response = await ApiServices.get(ApiServiceTypes.RoundsService).checkResultHash(postData);
  //   setCheckHashValue(response.data.result);
  // };

  // const t = useTranslation();

  useEffect(() => {
    setToggle(false);
  }, []);

  useEffect(() => {
    if (toggle && scrollRef.current) {
      scrollRef.current.scrollIntoView();
    }
  }, [toggle]);

  // useEffect(() => {
  //   return () => {
  //     setCheckKeyValue('');
  //     setCheckSaltValue('');
  //   };
  // }, []);

  return (
    <div className='hash-code-wrp'>
      <ResultImg dataForResultImage={selectedResultInfo} isFromResultHistory />
      <div className='bc-forms-holder'>
        <FairnessFormGroup isShowCopyIcon isCheckResult isShowAboutHash aboutHashComp={AboutHash} />
      </div>
    </div>
  );
});
